<template>
  <footer class="page-footer font-small unique-color-dark">
    <div class="container text-center text-md-left pt-5">
      <div class="row mt-3">
        <div class="col-md-4 col-lg-5 col-xl-4 mx-auto mb-4 border-right">
          <div class="row">
            <div class="col-md-6">
              <h6 class="mb-3">{{ getText("download_app_text") }}</h6>
              <p>
                <img
                  :src="this.globalConfig.footer_device_image_playstore"
                  class="app-image"
                  @click="gotoAppStore('google')"
                />
              </p>
              <p>
                <img
                  :src="this.globalConfig.footer_device_image_iosstore"
                  class="app-image"
                  @click="gotoAppStore('apple')"
                />
              </p>
            </div>
            <div class="col-md-6">
              <h6 class="">Connect with us </h6>
              <p class="social">
                <a
                  v-for="(media, index) in socialMedia"
                  :key="index"
                  :href="media.link"
                  class="mr-3"
                  ><i
                    v-if="media.name == 'facebook'"
                    class="fa fa-facebook-official"
                    aria-hidden="true"
                  ></i>
                  <i
                    v-if="media.name == 'instagram'"
                    class="fa fa-instagram"
                    aria-hidden="true"
                  ></i>
                  <i
                    v-if="media.name == 'twitter'"
                    class="fa fa-twitter"
                    aria-hidden="true"
                  ></i>
                  <i
                    v-if="media.name == 'youtube'"
                    class="fa fa-youtube-play"
                    aria-hidden="true"
                  ></i
                ></a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
          <h6 class="mb-4">Quick Links</h6>
          <p>
            <a href="/#/home">{{ getText("quicklinks_home_title") }}</a>
          </p>
          <p>
            <a href="/#/cookiesprivacy">{{ getText("quicklinks_cookiepolicy_title") }}</a>
          </p>
          <p>
            <a href="/#/cookiesprivacy">{{ getText("quicklinks_privacypolicy_title") }}</a>
          </p>
          <p>
            <a href="/#/terms">{{ getText("quicklinks_termsofuse_title") }}</a>
          </p>
          <p>
            <a href="/#/faqs">{{ getText("quicklinks_faq_title") }}</a>
          </p>
        </div>
        <div class="col-md-auto col-lg-auto mx-auto mb-md-0 mb-4">
          <h6 class="mb-4">Contact Support</h6>
          <p><i class="fa fa-whatsapp mr-3"></i>{{ getText("contact_phone_number1") }}</p>
          <p><i class="fa fa-whatsapp mr-3"></i>{{ getText("contact_phone_number2") }}</p>
          <p>
            <a href="mailto:support@ibakatv.com" target="_blank"
              >{{ getText("contact_email") }}</a
            >
          </p>
        </div>
        <div class="col-md-3 col-lg-auto mx-auto mb-4">
          <h6 class="mb-4">Services</h6>
          <p>
            <a href="#!">{{ getText("services_company_title") }}</a>
          </p>
          <p>
            <a href="/#/mediacenter">{{ getText("services_helpcentre_title") }}</a>
          </p>
          <p>
            <a href="#!">{{ getText("services_career_title") }}</a>
          </p>
          <p>
            <a href="/#/contact">{{ getText("services_contactus_title") }}</a>
          </p>
          <p>
            <a href="#!">Purchase Voucher</a>
          </p>
        </div>
      </div>
    </div>
    <div class="footer-copyright text-center py-3">
      {{ getText("copyright_text") }}
    </div>
  </footer>
</template>

<script>
import Footergrid from "@/components/Footergrid.vue";
export default {
  name: "Footer",
  components: {
    Footergrid,
  },
  data() {
    return {
      socialMedia: [],
       globalConfig:null
    };
  },
  created() {
    this.socialMedia = JSON.parse(
      this.$store.state.globalconfigs.footer_social_icon
    );
    this.globalConfig = this.$store.getters.getGlobalConfigs;
  },

  methods: {
    getText(val) {
      return this.$store.getters.getGlobalConfigs[val];
    },
    gotoAppStore(type) {
      if (type == "google") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
          "_blank"
        );
      } else if (type == "apple") {
        window.open(
          "https://apps.apple.com/gm/app/ibakatv/id1060646446",
          "_blank"
        );
      }
    },
  },
};
</script>

<style scoped>

.app-image {
  cursor: pointer;
  width: 119px;
  height: 35px;
  object-fit: cover;
}

</style>
